<mat-spinner *ngIf="displayLoader" [diameter]="diameter"></mat-spinner>